import { Box, Card, CardContent, CardHeader, CardMedia, Container, Grid, Typography } from "@mui/material"
import CircleIcon from '@mui/icons-material/Circle';
import { green, grey, red, yellow } from "@mui/material/colors";

const About = () => {
  return(
    <>
      <Box
        component="main"
        sx={{
          backgroundColor: '#f5f5f5',
          flexGrow: 1,
          py: 8
        }}
      >
        <Container maxWidth="lg">

          <Typography
            sx={{ mb: 7 }}
            variant="h4"
            align="center"
            letterSpacing= '6px' 
            textTransform= 'uppercase'
          >
            About Me
          </Typography>

          <Grid container>
            <Grid item xs={12} sm={6} md={6} align="center" paddingTop={2}>
              <Card sx={{ maxWidth: 345, boxShadow: 5 }}>
                <CardMedia
                  component="img"
                  height="200"
                  image="my_profile.jpg"
                  alt="Profile"
                />
                <CardContent>
                  {/* <Typography gutterBottom variant="h5" component="div">
                    Me
                  </Typography> */}
                  <Typography variant="body2" color="text.secondary">
                    Do you fancy saying hai to me or you want to get started with your project and you need my help? Feel free to contact me <i>deddyscareer@gmail.com</i>.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={6} align="left" paddingTop={2}>
              <Card sx={{ maxWidth: 560 }}>
                <CardHeader avatar={
                  <>
                  <CircleIcon style={{ fontSize: 12, marginRight: 8 }} sx={{ color: red[500] }} />
                  <CircleIcon style={{ fontSize: 12, marginRight: 8 }} sx={{ color: yellow[500] }} />
                  <CircleIcon style={{ fontSize: 12, marginRight: 8 }} sx={{ color: green[500] }} />
                  </>
                } sx={{bgcolor: grey[200]}} />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    Hai All,
                  </Typography>
                  <Typography variant="body2">
                  👋 I'm Deddy. I have more than two years of experience as a back end developer when I was studying in college. I am responsible for the security and data communications. In addition, I help build workflows against application behavior. Apart from technical skills, I am eager to interact with people as well as improve my communication skills and Highly motivated to develop my skills in IT and grow professionally. 🔥
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

          </Grid>


        </Container>
      </Box>
      
    </>
  )
}

export default About